<template>
  <div class="main">
    <b-card>

      <b-row class="justify-content-between">

        <b-col cols="12"  md="2" sm="1" class="my-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">Per page</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              
            />
          </b-form-group>
        </b-col>
        <b-col md="6" class="d-flex align-items-center justify-content-end my-1">
          <b-button v-if="HasPermission(PermissionList.HRMS_Create)" variant="primary" :to="{ name: 'add-employee' }">
            <feather-icon icon="PlusIcon" />
            New Employee
          </b-button>
        </b-col>
        <b-col cols="12" class="d-flex justify-content-end mb-2 my-1" style="position: relative; z-index: 1;">
          <b-button v-if="HasPermission(PermissionList.HRMS_Search)" variant="outline-danger"  @click="clearFilters">
            Clear Filters
          </b-button>
        </b-col>

        <b-col cols="12">
          <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredEmployees"
            :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
            @filtered="onFiltered">

            <!-- Column Header with Filter Inputs -->
            <template #head(firstName)="scope">
              <div class="d-flex flex-column">
                <span @click="toggleSort('firstName')" style="cursor: pointer">Name</span>
                <b-form-input v-model="filters.firstName" placeholder="Filter by Name" @input="applyFilters"
                  size="sm" />
              </div>
            </template>

            <template #head(departmentName)="scope">
              <div class="d-flex flex-column">
                <span @click="toggleSort('departmentName')" style="cursor: pointer">Department</span>
                <b-form-input v-model="filters.departmentName" placeholder="Filter by Department" @input="applyFilters"
                  size="sm" />
              </div>
            </template>

            <template #head(designationName)="scope">
              <div class="d-flex flex-column">
                <span @click="toggleSort('designationName')" style="cursor: pointer">Designation</span>
                <b-form-input v-model="filters.designationName" placeholder="Filter by Designation"
                  @input="applyFilters" size="sm" />
              </div>
            </template>

            <template #head(email)="scope">
              <div class="d-flex flex-column">
                <span @click="toggleSort('email')" style="cursor: pointer">Email</span>
                <b-form-input v-model="filters.email" placeholder="Filter by Email" @input="applyFilters" size="sm" />
              </div>
            </template>

            <template #head(hireDate)="scope">
              <div class="d-flex flex-column">
                <span @click="toggleSort('hireDate')" style="cursor: pointer">Joining Date</span>
                <DatePicker v-model="filters.hireDateRange" range format="YYYY-MM-DD" placeholder="Select date range"
                  @change="applyFilters" style="width: 100%;" />
              </div>
            </template>

            <template #head(status)="scope">
                <div class="d-flex flex-column">
                  <span>{{ scope.label }}</span>
                  <b-form-select v-model="filters.status" :options="statusFilterOptions" size="sm" />
                </div>
              </template>

            <!-- <template #head(status)="scope">
              <div class="d-flex flex-column">
                <span @click="toggleSort('status')" style="cursor: pointer">Status</span>
                <DatePicker v-model="filters.hireDateRange" range 
                  @change="applyFilters" style="width: 100%;" />
              </div>
            </template> -->

            <template #cell(firstName)="data">
              {{ formatName(data.item) }}
            </template>

            <template #cell(hireDate)="data">
              {{ formatDate(data.item) }}
            </template>

            <!-- <template #cell(status)="data">
              <b-badge :variant="status[1][data.value]">
                {{ status[0][data.value] }}
              </b-badge>
            </template> -->

            <template v-slot:cell(actions)="data">
              <b-dropdown
                variant="link"
                toggle-class="p-0"
                no-caret
                class="m-1"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item
                  v-if="HasPermission(PermissionList.HRMS_View)"
                  :to="{
                    name: 'view-employee',
                    params: { id: data.item.id },
                  }"
                >
                  <feather-icon icon="EyeIcon" />
                  <span class="align-middle ml-50">View</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="HasPermission(PermissionList.HRMS_Edit)"
                  :to="{
                    name: 'edit-employee',
                    params: { id: data.item.id },
                  }"
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Edit</span>
                </b-dropdown-item>
                <b-dropdown-item 
                  v-if="HasPermission(PermissionList.HRMS_Delete) && data.item.status !== 'ACTIVE'" @click="ActivateEmployee('ACTIVE', data.item.id, data.item)">
                  <feather-icon icon="CheckCircleIcon" />
                  <span class="align-middle ml-50">Activate</span>
                </b-dropdown-item>
                <b-dropdown-item 
                  v-if="HasPermission(PermissionList.HRMS_Delete) && data.item.status !== 'INACTIVE'" @click="DeactivateEmployee('INACTIVE', data.item.id, data.item)">
                  <feather-icon icon="XCircleIcon" />
                  <span class="align-middle ml-50">Deactivate</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <b-modal
            id="modal-edit-leave-request"
            ok-only
            ok-title="Edit"
            centered
            size="lg"
            title="Edit Leave Request"
            :hide-footer="true"
            ref="editLeaveRequest"
          >
            <EditLeaveRequest @refresh="refreshData" />
          </b-modal>
        </b-col>

        <b-col cols="12">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BDropdown,
  BLink,
  BDropdownItem,
  BTab,
  BTabs,
  BFormDatepicker,
} from "bootstrap-vue";

import { mapActions, mapGetters } from "vuex";
import { customLoader, customError, customSwal } from "@/libs/customFn";
import { PermissionList } from '@/libs/defaultList';
import { HasPermission, IsAdmin } from '@/@core/utils/validations/permissionCheck';
export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BLink,
    BDropdownItem,
    BTab,
    BTabs,
    BFormDatepicker,
    DatePicker
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      selectedDate: null,
      employeeListing: [],
      filterOn: [
        "firstName",
        "departmentName",
        "designationName",
        "email",
        "hireDate",
        "status"
      ],
      sortDesc: null,
      sortBy: null,
      sortDirection: null,
      filters: {
        firstName: '',
        departmentName: '',
        designationName: '',
        email: '',
        hireDateRange: [null, null],
        status: null,
      },
      fields: [],
      statusFilterOptions: [
        { value: null, text: "All" },
        { value: "ACTIVE", text: "Active" },
        { value: "INACTIVE", text: "Inactive" },
      ],
      deleteLoader: null
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("employeeModule", {
      employeeList: "employees",
      loading: "loading",
    }),
    filteredEmployees() {
      return this.employeeListing.filter(employee => {
        const fullName = `${employee.firstName} ${employee.lastName}`.toLowerCase();
        const hireDate = new Date(employee.hireDate);
        const [startDate, endDate] = this.filters.hireDateRange;
        const status =
          !this.filters.status || employee.status === this.filters.status;

        return (
          (!this.filters.firstName || fullName.includes(this.filters.firstName.toLowerCase())) &&
          (!this.filters.departmentName || employee.departmentName.toLowerCase().includes(this.filters.departmentName.toLowerCase())) &&
          (!this.filters.designationName || employee.designationName.toLowerCase().includes(this.filters.designationName.toLowerCase())) &&
          (!this.filters.email || employee.email.toLowerCase().includes(this.filters.email.toLowerCase())) &&
          (!startDate || hireDate >= new Date(startDate)) &&
          (!endDate || hireDate <= new Date(endDate)) &&
          (status)
        );
      });
    }
  },
  async mounted() {
    this.fields = IsAdmin() ?
        [
          { key: "firstName", label: "Name", sortable: true },
          { key: "departmentName", label: "Department", sortable: true },
          { key: "designationName", label: "Designation", sortable: true },
          {
            key: "email",
            label: "Email",
            sortable: true,
          },
          { key: "hireDate", label: "Joining Date", sortable: true },
          { key: "status", label: "Status", sortable: true },
          { key: "actions", label: "Actions" },
        ]
      :
        [
          { key: "firstName", label: "Name", sortable: true },
          { key: "departmentName", label: "Department", sortable: true },
          { key: "designationName", label: "Designation", sortable: true },
          {
            key: "email",
            label: "Email",
            sortable: true,
          },
          { key: "hireDate", label: "Joining Date", sortable: true },
          { key: "status", label: "Status", sortable: true },
        ]
      ;
    await this.getEmployeeListAction();
    this.totalRows = this.employeeList.length;
    this.employeeListing = [...this.employeeList];
  },
  methods: {
    orderFilterChanged() {
      const formatToYYYYMMDD = date => {
        const d = new Date(date);
        const month = '' + (d.getMonth() + 1);
        const day = '' + d.getDate();
        const year = d.getFullYear();
        return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-');
      };
      // Map the employeeList to include formatted hire dates
      const formattedEmployeeList = this.employeeList.map(employee => ({
        ...employee,
        formattedHireDate: formatToYYYYMMDD(employee.hireDate)
      }));

      console.log("formattedEmployeeList", formattedEmployeeList);
      console.log("this.selectedDate", this.selectedDate);
      if (this.selectedDate) {
        this.employeeListing = formattedEmployeeList.filter((employee) => {
          return employee.formattedHireDate === this.selectedDate;
        });
      console.log("this.employeeListing on filter", this.employeeListing);
    }else {
        this.employeeListing = [...this.employeeList];
      }
      this.totalRows = this.employeeListing.length;
      this.currentPage = 1;
    },
    refreshData() {},
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    ...mapActions("employeeModule", [
      "getEmployeeListAction",
      "removeEmployeeAction",
      "updateEmployeeAction"
    ]),
    formatName: (employee) => `${employee.firstName} ${employee.lastName}`,
    formatDate: (employee) =>
      new Date(employee.hireDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }),

    successActive() {
      this.$swal({
        title: "Activated!",
        text: "Employee is activated",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    successInactive() {
      this.$swal({
        title: "Deactivated!",
        text: "Employee is deactivated",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    async ActivateEmployee(status, id, details) {
    const result = await this.$swal({
        title: "Are you sure?",
        text: "You want to activate the employee!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Activate!",
        cancelButtonText: "Cancel",
        customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
    });

    if (result.isConfirmed) {
        details.status = status;
        try {
            await this.updateEmployeeAction(details);

            this.successActive();
            
            await this.getEmployeeListAction();
        } catch (error) {
            console.error("Error during employee activation:", error);
            if (error.response && error.response.data) {
                let errorMessage = "An unexpected error occurred.";
                if (error.response.data.errors) {
                    errorMessage = Object.values(error.response.data.errors)
                        .flat()
                        .join("\n");
                } else if (error.response.data.title) {
                    errorMessage = error.response.data.title;
                }

                await this.$swal({
                    title: "Error",
                    text: errorMessage,
                    icon: "error",
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                });
            }
            else{
            await this.$swal({
                title: "Error",
                text: "An error occurred while activating the employee.",
                icon: "error",
                customClass: {
                    confirmButton: "btn btn-danger",
                },
            });}

            
        }
    }
},

      async DeactivateEmployee(status, id, details) {
    const result = await this.$swal({
        title: "Are you sure?",
        text: "You want to deactivate the employee!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Deactivate!",
        cancelButtonText: "Cancel",
        customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
    });

    if (result.isConfirmed) {
        details.status = status;
        try {
            await this.updateEmployeeAction(details);
            this.successInactive();
            await this.getEmployeeListAction();
        } catch (error) {
            console.log("Error during employee deactivation:", error);
            if (error.response && error.response.data) {
                let errorMessage = "An unexpected error occurred.";
                if (error.response.data.errors) {
                    errorMessage = Object.values(error.response.data.errors)
                        .flat()
                        .join("\n");
                } else if (error.response.data.title) {
                    errorMessage = error.response.data.title;
                }
                await this.$swal({
                    title: "Error",
                    text: errorMessage,
                    icon: "error",
                    customClass: {
                        confirmButton: "btn btn-danger",
                    },
                });
            }
            else{
            await this.$swal({
                title: "Error",
                text: "An error occurred while deactivating the employee.",
                icon: "error",
                customClass: {
                    confirmButton: "btn btn-danger",
                },
            });}
            
        }
    }
},

    //  removeEmployee(id) {
    //   this.$swal({
    //     title: "Are you sure?",
    //     text: "You won't be able to revert this!",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonText: "Yes, delete it!",
    //     customClass: {
    //       confirmButton: "btn btn-primary",
    //       cancelButton: "btn btn-outline-danger ml-1",
    //     },
    //     buttonsStyling: false,
    //   }).then((result) => {
    //     if (result.value) {
    //       this.deleteLoader = customLoader(
    //         "Please wait while employee is being removed"
    //       );
    //       this.removeEmployeeAction(id)
    //         .then((response) => {
    //           console.log(response);

    //           this.deleteLoader.close();
    //           customSwal("Employee has been deleted", "Deleted!");
    //           this.getEmployeeListAction();
    //         })
    //         .catch((error) => {
    //           this.deleteLoader.close();
    //           customError(error.response.data, "Error");
    //           this.getEmployeeListAction();
    //         });
    //     } else if (result.dismiss === "cancel") {
    //       customSwal("Employee not deleted", "Cancelled", "error");
    //     }
    //   });
    // },

    // async removeEmployee(id) {
    //   this.$swal({
    //     title: 'Are you sure?',
    //     text: "You won't be able to revert this!",
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonText: 'Yes, delete it!',
    //     customClass: {
    //       confirmButton: 'btn btn-primary',
    //       cancelButton: 'btn btn-outline-danger ml-1',
    //     },
    //     buttonsStyling: false,
    //   }).then((result) => {
    //     if (result.value) {
    //       this.removeEmployeeAction(id)
    //         .then(() => {
    //           this.$swal({
    //             icon: 'success',
    //             title: 'Deleted!',
    //             text: 'Employee has been deleted',
    //             customClass: {
    //               confirmButton: 'btn btn-success',
    //             },
    //           });
    //           this.getEmployeeListAction().then(() => {
    //             this.totalRows = this.employeeList.length;
    //             this.employeeListing = [...this.employeeList];
    //           });
    //           //window.location.reload();
    //         })
    //         .catch((error) => {
    //           this.$swal({
    //             icon: 'error',
    //             title: 'Error!',
    //             text: error.response.data.message,
    //             customClass: {
    //               confirmButton: 'btn btn-success',
    //             },
    //           });
    //           this.getEmployeeListAction().then(() => {
    //             this.totalRows = this.employeeList.length;
    //           });
    //         });
    //     } else if (result.dismiss === 'cancel') {
    //       this.$swal({
    //         title: 'Cancelled',
    //         text: 'Employee not deleted',
    //         icon: 'error',
    //         customClass: {
    //           confirmButton: 'btn btn-success',
    //         },
    //       });
    //     }
    //   });
    // },

    applyFilters() {
      this.currentPage = 1; // Reset to the first page when filters are applied
    },
    clearFilters() {
      // Reset all filters
      this.filters = {
        firstName: '',
        departmentName: '',
        designationName: '',
        email: '',
        hireDateRange: [null, null], // Reset date range filter
      };

      // Reset the current page and filtered items
      this.currentPage = 1;
    }
  },
  setup(props) {
    return {
      PermissionList,
      HasPermission,
      IsAdmin
    }
  }
};
</script>
